import history from '../../util/history'

const cancelTaskView = reservationId => {
  history.replace(`/reservation/${reservationId}/detail`)

  return true
}

export default cancelTaskView
